declare namespace $ {

	type $mol_view__sub_rise_devtools_selector_overlay_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_rise_devtools_selector_overlay_2 = $mol_type_enforce<
		ReturnType< $rise_devtools_selector_overlay['panel_content'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__style_rise_devtools_selector_overlay_3 = $mol_type_enforce<
		({ 
			'top': ReturnType< $rise_devtools_selector_overlay['panel_top'] >,
			'bottom': ReturnType< $rise_devtools_selector_overlay['panel_bottom'] >,
			'maxWidth': ReturnType< $rise_devtools_selector_overlay['panel_max_width'] >,
			'maxHeight': ReturnType< $rise_devtools_selector_overlay['panel_max_height'] >,
			'overflow': string,
		})  & ReturnType< $mol_view['style'] >
		,
		ReturnType< $mol_view['style'] >
	>
	type $mol_view__sub_rise_devtools_selector_overlay_4 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $rise_devtools_selector_overlay_files__target_info_rise_devtools_selector_overlay_5 = $mol_type_enforce<
		ReturnType< $rise_devtools_selector_overlay['target_info'] >
		,
		ReturnType< $rise_devtools_selector_overlay_files['target_info'] >
	>
	type $rise_devtools_selector_overlay_files__rpc_port_rise_devtools_selector_overlay_6 = $mol_type_enforce<
		ReturnType< $rise_devtools_selector_overlay['rpc_port'] >
		,
		ReturnType< $rise_devtools_selector_overlay_files['rpc_port'] >
	>
	export class $rise_devtools_selector_overlay extends $mol_view {
		content( ): readonly(any)[]
		panel_content( ): readonly(any)[]
		panel_top( ): string
		panel_bottom( ): string
		panel_max_width( ): string
		panel_max_height( ): string
		target_title( ): string
		Title( ): $mol_view
		target_info( ): any
		rpc_port( ): string
		display( ): string
		left_px( ): string
		top_px( ): string
		width_px( ): string
		height_px( ): string
		pointer_events( ): string
		active( ): boolean
		rect( ): any
		target_id( next?: string ): string
		target_name( ): string
		target_attrs( next?: readonly(any)[] ): readonly(any)[]
		selected( next?: boolean ): boolean
		visible( ): boolean
		sub( ): ReturnType< $rise_devtools_selector_overlay['content'] >
		Panel( ): $mol_view
		Label( ): $mol_view
		Files( ): $rise_devtools_selector_overlay_files
		style( ): ({ 
			'display': ReturnType< $rise_devtools_selector_overlay['display'] >,
			'left': ReturnType< $rise_devtools_selector_overlay['left_px'] >,
			'top': ReturnType< $rise_devtools_selector_overlay['top_px'] >,
			'width': ReturnType< $rise_devtools_selector_overlay['width_px'] >,
			'height': ReturnType< $rise_devtools_selector_overlay['height_px'] >,
			'pointerEvents': ReturnType< $rise_devtools_selector_overlay['pointer_events'] >,
		})  & ReturnType< $mol_view['style'] >
	}
	
}

//# sourceMappingURL=overlay.view.tree.d.ts.map